module.exports = {
  formatCurrencyCompact: (amountInCents, currency) => {
    const amount = amountInCents / 100.0

    return `${new Intl.NumberFormat("en-CA", {
      style: "currency",
      currency,
      currencyDisplay: "narrowSymbol",
      minimumFractionDigits: amount % 1 === 0 ? 0 : 2,
      maximumFractionDigits: 2,
    })
      .format(amount)
      .replace("US$", "$")}`
  },
  formatCurrency: (amountInCents, currency) => {
    const amount = amountInCents / 100.0

    const symbol = currency.toLowerCase() === "cad" ? "CA$" : "US$"

    return `${new Intl.NumberFormat("en-CA", {
      style: "currency",
      currency,
      minimumFractionDigits: amount % 1 === 0 ? 0 : 2,
      maximumFractionDigits: 2,
    })
      .format(amount)
      .replace("US$", "$")
      .replace("$", symbol)}`
  },
  formatDiscount: (discount) => {
    return new Intl.NumberFormat("en-US", {
      style: "percent",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(discount)
  },
}
